/*
 * pic-nn-web-ui
 *
 * Web UI for neural network applications.
 *
 * @copyright 2020 VSTE CB <http://www.vstecb.cz/>.
 * @license See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { IOutputCommonProps, OutputWrapper } from "./OutputWrapper";
import { ModelOutput } from "../../shared/model/ModelOutput";
import { formatNumericValue } from "../../shared/helpers";

/**
 * Component props
 */
export interface IOutputNumberProps extends IOutputCommonProps<ModelOutput<number>> {
	/** Output field */
	output: ModelOutput<number>;

	/** Suffix label, eg. for unit or currency */
	suffix?: string;

	/** Number of decimals to format number to */
	decimals?: number;

	/** Custom multiplier (eg. for percentage) */
	multiplier?: number;
}

/**
 * Number output field component
 *
 * @param props Props
 */
export function OutputNumber(props: IOutputNumberProps) {

	return <OutputWrapper {...props} render={(state, baseStyle) => {

		const decimals = props.decimals || state.config.decimals;
		const multiplier = props.multiplier || state.config.multiplier;

		const val = formatNumericValue(state.value, decimals, multiplier);

		return <>
			<span className={baseStyle.el("value").className()}>{val}</span>
			{props.suffix || state.config.suffix ?
			<span className={baseStyle.el("suffix").className()}> {props.suffix || state.config.suffix}</span>
			: null}
		</>;
	}} />;

}
